import * as OnboardingActions from 'actions/OnboardingActions';
import {EventConstants} from 'constants/EventConstants';
import * as UserDAO from 'dao/UserDAO';
import AppDispatcher from 'lib/Dispatcher';
import * as net from 'util/Net';
import notifications from 'notifications';
import EntityStore from 'stores/EntityStore';

export function loadOrgs() {
  AppDispatcher.dispatch({
    actionType: EventConstants.ORG_FETCH,
  });

  UserDAO.getCurrentOrgs()
    .done((response) => {
      AppDispatcher.dispatch({
        actionType: EventConstants.ORG_FETCH_COMPLETED,
        entityId: EntityStore.currentUser().id,
        orgs: response,
      });
    })
    .fail((response) => {
      AppDispatcher.dispatch({
        actionType: EventConstants.ORG_FETCH_FAILED,
        error: response,
      });
    });
}

export function loadOrgRequests() {
  UserDAO.getOrgRequests()
    .done((response) => {
      AppDispatcher.dispatch({
        actionType: EventConstants.USER_FETCH_ORG_REQUESTS_COMPLETED,
        entityId: EntityStore.currentUser().id,
        userOrgsInboundRequests: response.userOrgsInboundRequests,
        currentUserInboundRequests: response.currentUserInboundRequests,
        pendingOrgInvites: response.pendingInvites,
        currentUserOutboundRequests: response.currentUserOutboundRequests,
      });
    })
    .fail(notifications.notifyError);
}

export function dismissAllOrgInvites() {
  const userId = EntityStore.currentUser().id;
  const currentPendingInvites = EntityStore.getEntity(userId).pendingOrgInvites;
  AppDispatcher.dispatch({
    actionType: EventConstants.USER_DISMISS_ALL_ORG_INVITES,
    userId,
  });
  net
    .post({url: '/1/api/users/me/actions/dismiss-organization-invites'})
    .fail(() => {
      AppDispatcher.dispatch({
        actionType: EventConstants.USER_DISMISS_ALL_ORG_INVITES_FAILED,
        originalPendingInvites: currentPendingInvites,
        userId,
      });
    })
    .fail(notifications.notifyError);
}

export function createInboundRequest(orgId) {
  UserDAO.createInboundRequest(orgId).fail(notifications.notifyError);
}

export function acceptOutboundRequest(orgId) {
  const organization = EntityStore.getEntity(orgId);
  AppDispatcher.dispatch({
    actionType: EventConstants.USER_ACCEPT_ORG_REQUEST,
    organizationId: orgId,
    userId: EntityStore.currentUser().id,
  });
  UserDAO.acceptOutboundRequest(orgId)
    .done(() => {
      OnboardingActions.fetchOnboardingTasks();
      notifications.success(`Successfully joined ${organization.name}.`);
    })
    .fail(notifications.notifyError);
}

export function rejectOutboundRequest(orgId) {
  const organization = EntityStore.getEntity(orgId);
  AppDispatcher.dispatch({
    actionType: EventConstants.USER_REJECT_ORG_REQUEST,
    organizationId: orgId,
    userId: EntityStore.currentUser().id,
  });
  UserDAO.rejectOutboundRequest(orgId)
    .done(() => {
      notifications.success(`Successfully rejected ${organization.name}'s invite.`);
    })
    .fail(notifications.notifyError);
}

export function getReferrals() {
  UserDAO.getReferrals().done(({data}) => {
    AppDispatcher.dispatch({
      actionType: EventConstants.USER_FETCH_REFERRALS,
      userId: EntityStore.currentUser().id,
      referrals: data,
    });
  });
}

export function getOrMakePublicReferralId(email) {
  UserDAO.getPublicReferralId(email)
    .done(({referralLinkId}) => {
      AppDispatcher.dispatch({
        actionType: EventConstants.USER_FETCH_REFERRAL_LINK_ID,
        referralLinkId,
        email,
      });
    })
    .fail(() => {
      UserDAO.createPublicReferralId(email).done(({referralLinkId}) => {
        AppDispatcher.dispatch({
          actionType: EventConstants.USER_FETCH_REFERRAL_LINK_ID,
          referralLinkId,
          email,
        });
      });
    });
}

export function loadMetadata() {
  UserDAO.getMetadata().done((metadata) => {
    AppDispatcher.dispatch({
      actionType: EventConstants.USER_FETCH_METADATA,
      userId: EntityStore.currentUser().id,
      metadata,
    });
  });
}
